import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { PrButtonAddModule } from '../pr-button/pr-button-add/pr-button-add.module';
import { PrButtonConfirmModule } from '../pr-button/pr-button-confirmation/pr-button-confirm.module';
import { PrButtonModule } from '../pr-button/pr-button/pr-button.module';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrLoaderModule } from '../pr-loader/pr-loader.module';
import { PrCityFinderModule } from '../pr-city-finder/pr-city-finder.module';
import { PrSearchInputModule } from '../pr-search-input/pr-search-input.module';
import { PrTableModule } from '../pr-table/pr-table.module';
import { ControlValueAccessorComponent } from './control-value-accessor/control-value-accessor.component';
// import { PrCheckboxGroupModule } from "./pr-checkbox-group/pr-checkbox-group.module";
import { PrSelectSearchModule } from '../pr-select-search/pr-select-search.module';
import { CheckboxContainerComponent } from './pr-checkbox-group/checkbox-container/checkbox-container.component';
import { CheckboxComponent } from './pr-checkbox-group/checkbox/checkbox.component';
import { PrCheckboxGroupComponent } from './pr-checkbox-group/pr-checkbox-group.component';
import { PrErrorsComponent } from './pr-errors/pr-errors.component';
import { PrFormContainerComponent } from './pr-form-container/pr-form-container.component';
import { PrFormHostDirective } from './pr-form-container/pr-form-host.directive';
import { PrFormInputDateComponent } from './pr-form-input-date/pr-form-input-date.component';
import { PrFormInputSelectComponent } from './pr-form-input-select/pr-form-input-select.component';
import { PrFormListItemComponent } from './pr-form-list-item/pr-form-list-item.component';
import { PrFormSelectListModule } from './pr-form-select-list/pr-form-select-list.module';
import { PrFormComponent } from './pr-form/pr-form.component';
import { PrInputAbstractComponent } from './pr-input-abstract/pr-input-abstract.component';
import { PrInputAutosuggestComponent } from './pr-input-autosuggest/pr-input-autosuggest.component';
import { PrInputCheckboxComponent } from './pr-input-checkbox/pr-input-checkbox.component';
import { PrInputColumnComponent } from './pr-input-column/pr-input-column.component';
import { PrInputCountryComponent } from './pr-input-country/pr-input-country.component';
import { PrInputDateComponent } from './pr-input-date/pr-input-date.component';
import { PrInputIconMultiselectComponent } from './pr-input-icon-multiselect/pr-input-icon-multiselect.component';
import { PrInputMapComponent } from './pr-input-map/pr-input-map.component';
import { PrInputMapsComponent } from './pr-input-maps/pr-input-maps.component';
import { PrInputOwnerComponent } from './pr-input-owner/pr-input-owner.component';
import { PrInputOwnerShareComponent } from './pr-input-owner-share/pr-input-owner-share.component';
import { PrInputPercentComponent } from './pr-input-percent/pr-input-percent.component';
import { PrInputProductComponent } from './pr-input-product/pr-input-product.component';
import { PrInputRadioRoundComponent } from './pr-input-radio-round/pr-input-radio-round.component';
import { PrInputStringListComponent } from './pr-input-string-list/pr-input-string-list.component';
import { PrInputRadioComponent } from './pr-input-radio/pr-input-radio.component';
import { PrInputSelectTemplateComponent } from './pr-input-select-template/pr-input-select-template.component';
import { PrInputSliderComponent } from './pr-input-slider/pr-input-slider.component';
import { PrInputTelComponent } from './pr-input-tel/pr-input-tel.component';
import { PrInputComponent } from './pr-input/pr-input.component';
import { PrSelectFormComponent } from './pr-select-form/pr-select-form.component';
import { PrSocialSecurityNumberDirective } from './pr-social-security-number/pr-social-security-number.directive';
import { PrSubformModule } from './pr-subform/pr-subform.module';
import { PrSuffixComponent } from './pr-suffix/pr-suffix.component';
import { PrTableFormModule } from './pr-table-form/pr-table-form.module';

export const DATE_PICKER_FORMAT = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

let COMPONENTS = [
  PrErrorsComponent,
  PrInputAbstractComponent,
  PrInputComponent,
  PrInputDateComponent,
  PrInputMapComponent,
  PrInputMapsComponent,
  PrInputIconMultiselectComponent,
  PrFormComponent,
  PrFormContainerComponent,
  PrFormHostDirective,
  PrFormListItemComponent,
  PrFormInputDateComponent,
  PrFormInputSelectComponent,
  PrInputRadioComponent,
  PrSelectFormComponent,
  PrInputAutosuggestComponent,
  PrInputOwnerComponent,
  PrInputOwnerShareComponent,
  PrInputSliderComponent,
  PrInputRadioRoundComponent,
  PrInputProductComponent,
  PrInputCheckboxComponent,
  PrSuffixComponent,
  PrInputColumnComponent,
  PrInputTelComponent,
  PrInputCountryComponent,
  PrInputSelectTemplateComponent,
  ControlValueAccessorComponent,
  PrCheckboxGroupComponent,
  CheckboxComponent,
  CheckboxContainerComponent,
  PrInputPercentComponent,
  PrInputStringListComponent,
  PrSocialSecurityNumberDirective,
];

const EXPORTEDMODULES = [
  PrSubformModule,
  PrFormSelectListModule,
  PrTableFormModule,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,

    ReactiveFormsModule,
    FormsModule,
    NgxIntlTelInputModule,
    NgxMaskDirective,
    NgxMaskPipe,
    PrIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatSliderModule,
    PrButtonModule,
    PrButtonAddModule,
    PrButtonConfirmModule,
    PrTableModule,
    PrSearchInputModule,
    PrSelectSearchModule,
    PrCityFinderModule,
    // PrCheckboxGroupModule,
    PrLoaderModule,
    MatDividerModule,
    TooltipModule,
    GoogleMapsModule,
    ...EXPORTEDMODULES,
  ],
  exports: [...COMPONENTS, ...EXPORTEDMODULES],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: DATE_PICKER_FORMAT },
    provideNgxMask(),
  ],
})
export class PrFormModule {}
